import { useState } from "react";
import FabCreditCard from "./FabCreditCard";
import FabCreditTable from "./FabCreditTable";
import CustomerRedemption from "./ApplyFabCredit";
import WSButton from "../../Components/Button/WSButton";
import CreateFabCard from "./CreateFab";

const FabCredit = () => {
  const [card, setCard] = useState([
    {
      id: "1",
      cardId: "#123",
      points: 12,

      date: "17/08/2025",
      status: "pending"
    },
    {
      id: "2",
      cardId: "#103",
      points: 42,

      date: "10/08/2025",
      status: "paid"
    },
    {
      id: "3",
      cardId: "#181",
      points: 90,

      date: "22/08/2025",
      status: "paid"
    }
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [creditLimit, setCreditLimit] = useState(5000);
  const [creditUsed, setCreditUsed] = useState(1000);

  // const handleRepay = (amount: number) => {
  //   setCreditUsed(creditUsed - amount);
  //   setTransactions([
  //     ...transactions,
  //     {
  //       id: Math.random().toString(),
  //       type: "credit_payment",
  //       amount,
  //       date: new Date().toISOString().split("T")[0],
  //       status: "paid"
  //     }
  //   ]);
  //   setIsModalOpen(false);
  // };

  const handleCreate = async (data: any) => {
    const newCard = {
      id: (card.length + 1).toString(),
      cardId: `#${Math.floor(Math.random() * 900) + 100}`,
      points: data.points,

      date: data.date,
      status: data.status
    };
    setCard([...card, newCard]);
    alert("FAB Credit Card Created Successfully!");
  };

  return (
    <div style={{ padding: "20px" }}>
      <WSButton
        id="modal-btn"
        label="Create New Card"
        size="small"
        onClick={() => setIsModalOpen(true)}
        sx={{ mb: 3 }}
      />
      <FabCreditTable card={card} onRepay={() => setIsModalOpen(true)} />
      <CreateFabCard
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        handleCreate={handleCreate}
      />
      {/* <CustomerRedemption /> */}
    </div>
  );
};

export default FabCredit;
